import React from 'react';
import { List, Typography, Tag, Image } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as ShopIcon } from 'assets/icons/shop.svg';
import classname from 'classnames';
import classes from './Style.module.scss';

export default function FactoryListItem(props) {
  const {
    image,
    factoryId,
    address,
    name,
    extra,
    children,
    className,
    bordered,
    certifications = []
  } = props;
  return (
    <List.Item
      className={classname(classes.factory, className, {
        [classes.bordered]: bordered
      })}
    >
      <div className={classes.card}>
        <List.Item.Meta
          avatar={
            <Image
              preview={false}
              width={80}
              height={40}
              src={image}
              style={{ objectFit: 'contain' }}
            />
          }
          title={
            <span className={classes.group}>
              <Typography.Title className={classes.title} level={5}>
                {name}
              </Typography.Title>
              <p className={classes.caption}>{factoryId}</p>
            </span>
          }
          description={
            <span className={classes.group}>
              <span
                data-hidden={!certifications.length}
                className={classes.certifications}
              >
                {certifications.map((certification) => (
                  <Tag key={certification.id}>{certification.name}</Tag>
                ))}
              </span>

              <span className={classes.inline}>
                <Icon component={ShopIcon} />
                <p className={classes.caption}>{address}</p>
              </span>
            </span>
          }
        />
        {extra}
      </div>
      {children}
    </List.Item>
  );
}

// FactoryListItem.propTypes = {
//   image: PropTypes.string,
//   factoryId: PropTypes.string,
//   address: PropTypes.string,
//   name: PropTypes.string.isRequired,
//   bordered: PropTypes.bool,
//   extra: PropTypes.node,
//   children: PropTypes.node,
//   className: PropTypes.string,
//   certifications: PropTypes.array
// };

// FactoryListItem.defaultProps = {
//   bordered: true,
//   extra: null,
//   children: null,
//   className: '',
//   factoryId: '',
//   image: '',
//   address: '',
//   certifications: []
// };
